import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, Col, Form, Row } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; // Import React Icons
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

const GroupView = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { pointindex } = useParams();
  const [groupname, setgroupname] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [groups, setGroups] = useState([]); // State to hold the list of groups

  useEffect(() => {
    const fetchGroupData = async () => {
      try {
        const response = await axios.get(BASE_URL + "productGroup/findAllProductGroup", {
          headers: authHeader(),
        });
        console.log('all data', response.data)
        setGroups(response.data); // Store the list of groups
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch group data. Please try again.',
        });
      }
    };

    fetchGroupData();
  }, []);

  useEffect(() => {
    const fetchGroupDetails = async () => {
      try {
        const response = await axios.get(BASE_URL + "productGroup/findById/" + id, {
          headers: authHeader(),
        });
        setgroupname(response.data.groupname);
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch group data. Please try again.',
        });
      }
    };

    if (id) fetchGroupDetails();
  }, [id]);

  const validateForm = () => {
    if (!groupname) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Form',
        text: 'Please enter a group name.',
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsLoading(true);

    const groupData = {
      groupname: groupname,
    };

    try {
      await axios.put(BASE_URL + "productGroup/update", groupData, {
        headers: authHeader(),
      });
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Group added successfully!',
      });
      navigate("/groupindex/1");
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response.data,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const deleteHandler = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(BASE_URL + "productGroup/delete/" + id, {
            headers: authHeader(),
          })
          .then((response) => {
            if (response.data.length === 0) {
              Swal.fire(
                'Warning',
                'Group present in another module. Delete operation has been cancelled.',
                'warning'
              );
            } else {
              navigate(`/groupindex/${pointindex}`);
              Swal.fire('Deleted!', 'Deleted successfully.', 'success');
            }
          })
          .catch((error) => {
            Swal.fire('Error', error.response.data, 'error');
          });
      }
    });
  };

  // Function to get the next and previous group IDs
  const getNextPrevIds = () => {
    const currentIndex = groups.findIndex((group) => group.id === parseInt(id));
    const nextId = groups[currentIndex + 1]?.id;
    const prevId = groups[currentIndex - 1]?.id;
    return { nextId, prevId, currentIndex };
  };

  const { nextId, prevId, currentIndex } = getNextPrevIds();
  const totalGroups = groups.length;

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW GROUP</h6>
          <div className="view-buttons">
            <Link>
              <button className="button-70" onClick={() => deleteHandler(id)}>
                DELETE
              </button>
            </Link>
            <Link to={`/groupEdit/${id}/${pointindex}`}>
              <button className="button-70">EDIT</button>
            </Link>
            <Link to="/groupindex/1">
              <button className="button-70">BACK</button>
            </Link>
            {/* Previous and Next Buttons with React Icons */}
            {prevId && (
              <Link to={`/groupView/${prevId}/${pointindex}`}>
                <button className="button-70">
                  <FaArrowLeft /> Previous
                </button>
              </Link>
            )}
            {nextId && (
              <Link to={`/groupView/${nextId}/${pointindex}`}>
                <button className="button-70">
                  Next <FaArrowRight />
                </button>
              </Link>
            )}
          </div>
          {/* Display Current Index and Total */}
          <div className="pagination-info">
            {currentIndex !== -1 && (
              <span>
                {currentIndex + 1} of {totalGroups}
              </span>
            )}
          </div>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group controlId="formgroupname">
                  <Form.Label>Group Name</Form.Label>
                  <Form.Control
                    placeholder="Enter Group name"
                    value={groupname}
                    onChange={(e) => setgroupname(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default GroupView;
